var map = {
	"./img_1.jpg": 67118,
	"./img_2.jpg": 8651,
	"./img_3.jpg": 75948,
	"./img_4.jpg": 17486,
	"./img_5.jpg": 18388,
	"./img_6.jpg": 5084,
	"./img_7.jpg": 6197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30773;